import {
  getEducationFormList,
  getEducationList,
  pathCreateEducation,
  pathDeleteEducation,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { educationActions } from "../reducers/education";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchEducationList = (id_education = 0) => {
  return (dispatch) => {
    return apiService
      .get(getEducationList(id_education))
      .then((response) => {
        id_education == 0
          ? dispatch(educationActions.fetchEducationList(response.data))
          : dispatch(educationActions.fetchEducationDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const clearEducationDetail = () => {
  return (dispatch) => {
    dispatch(educationActions.fetchEducationDetail([]));
  };
};

export const fetchEducationFormList = (country_id = 0) => {
  return (dispatch) => {
    return apiService
      .get(getEducationFormList(country_id))
      .then((response) => {
        dispatch(educationActions.fetchEducationFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewEducation = (data, navigate) => {
  return async () => {
    try {
      const response = await apiService.postMultipart(
        pathCreateEducation(),
        data
      );
      navigate("/education-list");
      toast.success(t("educationListActions.created"), {
        theme: "colored",
      });
    } catch (err) {
      handleError(err);
    }
  };
};

export const createNewEducation1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreateEducation(), data)
      .then((response) => {
        // dispatch(educationActions.fetchEducationList(response.data));
        toast.success(t("educationListActions.created"), {
          theme: "colored",
        });
        navigate("/education-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditEducation = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .putMultipart(pathCreateEducation(), data)
      .then((response) => {
        // dispatch(educationActions.fetchEducationList(response.data));
        toast.success(t("educationListActions.updated"), {
          theme: "colored",
        });
        navigate("/education-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteEducation = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteEducation(id))
      .then((response) => {
        toast.success(t("educationListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchEducationList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
